import App from './App';
import './App.css';
import { renderApp } from './kernelBootstrap';

renderApp(App);
